/* eslint-disable */
<template>
<div class="question">
  <div class="body">
    <div class="body-content">
      <div>{{question.body}}</div>
    </div>
    <div class="body-option">
      <div v-for="(option, index) in question.option" :key="index">
        <div class="option">
            <input :name="question.id" type="checkbox" :value="isChecked(index)" @click="answer(index)"/>
            <div>{{option}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
require('@/assets/css/question.css')
export default {
  name: 'MultiChoiceQuestion',
  props: ['question'],
  data() {return {user_choice: []}},
  methods: {
    answer: function(i){
      let ind = this.user_choice.indexOf(i)
      if (ind > -1) {
        this.user_choice.splice(ind, 1)
      }else{
        this.user_choice.push(i)
      }
      console.log('user_choice: ' + this.user_choice)
      this.$emit('answer', this.question.id, this.user_choice)
    },
    isChecked: function(ind){
      return this.user_choice.indexOf(ind) > -1;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/template/question/MultiChoiceQuestion.vue